// Site key de reCAPTCHA v2, compartida por login y registro.
//
// Es publica por diseno: viaja en el HTML de cualquier sitio que use reCAPTCHA,
// asi que no hay nada que esconder aqui. La mitad que si es secreta es la
// secret key, que vive solo en el servidor (RECAPTCHA_SECRET) y es la que usa
// common/services/recaptcha.js de la API para validar el token contra Google.
//
// Estaba escrita a mano en las dos paginas; centralizarla evita que se separen
// y que una quede apuntando a un par de claves distinto del que espera el
// servidor.
//
// Con v2 no hace falta cargar nada a mano: el componente react-google-recaptcha
// inyecta el script de Google por su cuenta. Solo necesita la clave.
//
// REACT_APP_RECAPTCHA_SITE_KEY permite usar otra clave por entorno sin tocar
// codigo; CRA inyecta las variables REACT_APP_* en tiempo de compilacion.
export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6LfsBuQtAAAAADUMX7l5qNCGlFpBztYmDaeYxOjq";

export default RECAPTCHA_SITE_KEY;
